<template>
  <div class="title">
    {{ value.is_edit }}
    <span v-if="!value.is_edit" @click.stop.prevent="onEditFocus">{{
      value.name
    }}</span>
    <input type="text" v-model="value.name" v-else />
  </div>
</template>
<script>
export default {
  props: {
    value: null,
  },
  data() {
    return {};
  },
  methods: {
    onEditFocus() {
      this.$emit("edit-focus", true);
    },
  },
};
</script>